import Vue from 'vue'
import ElementUI from 'element-ui'
import './theme/blue/theme/index.css'
import App from './App'
import i18n from './lang'
import router from './router'
import store from './store/store'
import globalMixins from './mixins/globalMixins'
import dialogLoading from './util/dialogLoading'
import {bcadd, bcsub, bcmul, bcdiv, removeHtmlStyle, delayRun} from './util/util'
import VueMeta from 'vue-meta'

Vue.prototype.$math = {
  bcadd, bcsub, bcmul, bcdiv
}
Vue.prototype.$delayRun = delayRun
Vue.prototype.$trimStyle = removeHtmlStyle
Vue.prototype.$EventBus = new Vue()

// 根据当前语言环境设置Element UI的语言
const currentLocale = store.state.lang || 'zhCN'
let elementLocale
switch (currentLocale) {
  case 'en':
    elementLocale = require('element-ui/lib/locale/lang/en')
    break
  case 'zhHK':
    elementLocale = require('element-ui/lib/locale/lang/zh-TW')
    break
  default:
    elementLocale = require('element-ui/lib/locale/lang/zh-CN')
    break
}

Vue.use(ElementUI, {
  size: 'mini',
  locale: elementLocale.default || elementLocale
})

Vue.use(VueMeta)
Vue.use(dialogLoading)
Vue.mixin(globalMixins)
Vue.config.productionTip = false

// 添加全局方法用于动态切换Element UI语言
Vue.prototype.$changeElementUILocale = function (locale) {
  let elementLocale
  switch (locale) {
    case 'en':
      elementLocale = require('element-ui/lib/locale/lang/en')
      break
    case 'zhHK':
      elementLocale = require('element-ui/lib/locale/lang/zh-TW')
      break
    default:
      elementLocale = require('element-ui/lib/locale/lang/zh-CN')
      break
  }

  // 动态设置Element UI的语言
  const ELEMENT = require('element-ui')
  ELEMENT.locale(elementLocale.default || elementLocale)
}

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  metaInfo () {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: 'keywords',
          content: this.$store.state.metaInfo.keywords
        },
        {
          name: 'description',
          content: this.$store.state.metaInfo.description
        }
      ]
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js